<template>
  <div class="bg d-flex justify-content-center align-items-center">
    <div class="w-100">
      <form @submit.prevent="subMit" ref="myForm">
        <div class="home">
          <p class="text">ใส่คำอธิษฐานของของคุณได้เลย!!</p>
          <label class="text-white mt-2">คำอธิษฐาน</label>
          <b-form-input
            v-model="wish"
            type="text"
            class="opacity"
            required
          ></b-form-input>
          <!-- {{ $store.state.form.zodiac }} -->
          <!-- {{ $store.state.form.location }} -->
        </div>
        <button class="d-none" type="submit" ref="submitForm"></button>
        <b-container fluid>
          <!-- <b-img
            @click="submitForm"
            src="../assets/loy.png"
            class="btn-submit"
            style="padding-bottom:50px;"
          /> -->
          <button class="base-btn btn-submit" @click="submitForm">
            ลอยกระทง
          </button>
        </b-container>
      </form>
    </div>
  </div>
</template>

<script>
// import liff from "@line/liff";
export default {
  name: "Home",
  data() {
    return {
      zodiac: "",
      userId: "",
      displayName: "",
      wish: "",
      pictureUrl: "",
      srcimg: "",
    };
  },
  methods: {
    submitForm() {
      this.$refs.submitForm.click();
    },
    selectzodiac1() {
      this.$store.dispatch("setFrom", {
        zodiac: "1",
      });
      this.zodiac = 1;
    },
    selectzodiac2() {
      this.$store.dispatch("setFrom", {
        zodiac: "2",
      });
      this.zodiac = 2;
    },
    selectzodiac3() {
      this.$store.dispatch("setFrom", {
        zodiac: "3",
      });
      this.zodiac = 3;
    },
    selectzodiac4() {
      this.$store.dispatch("setFrom", {
        zodiac: "4",
      });
      this.zodiac = 4;
    },
    selectzodiac5() {
      this.$store.dispatch("setFrom", {
        zodiac: "5",
      });
      this.zodiac = 5;
    },
    selectzodiac6() {
      this.$store.dispatch("setFrom", {
        zodiac: "6",
      });
      this.zodiac = 6;
    },
    selectzodiac7() {
      this.$store.dispatch("setFrom", {
        zodiac: "7",
      });
      this.zodiac = 7;
    },
    selectzodiac8() {
      this.$store.dispatch("setFrom", {
        zodiac: "8",
      });
      this.zodiac = 8;
    },
    selectzodiac9() {
      this.$store.dispatch("setFrom", {
        zodiac: "9",
      });
      this.zodiac = 9;
    },
    selectzodiac10() {
      this.$store.dispatch("setFrom", {
        zodiac: "1o",
      });
      this.zodiac = 10;
    },
    selectzodiac11() {
      this.$store.dispatch("setFrom", {
        zodiac: "11",
      });
      this.zodiac = 11;
    },
    selectzodiac12() {
      this.$store.dispatch("setFrom", {
        zodiac: "12",
      });
      this.zodiac = 12;
    },
    subMit() {
      this.$store.dispatch("setFrom", {
        wish: this.wish,
      });
      this.$router.push("/loykathong");
    },
  },
  created() {
    this.displayName = this.$store.state.form.name;
    this.pictureUrl = this.$store.state.form.pictureUrl;
    console.log(this.$store.state.form);
  },
  mounted() {
    this.srcimg = this.$store.state.form.srcimg;
    var messageBody = document.querySelector("#messageBody");
    messageBody.scrollTop = 0;
    console.log(this.$store.state.form);
  },
};
</script>
<style scoped>
.bg {
  /* background-image: url("../assets/BG.png");
  background-repeat: no-repeat;
  height: 100vh; */
  /* background-image: url("../assets/background.jpg"); */
  background-repeat: no-repeat;
  /* background-size: 450px; */
  background-size: cover;
  height: 100vh;
}
.profile {
  width: 200px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.home {
  padding-top: 30px;
}
.opacity {
  background-color: rgba(0, 0, 0, 0.5);
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  /* margin-top: 30px; */
}
.text {
  color: white;
  margin-top: 20px;
  font-size: 20px;
}
.zodiac {
  width: 100%;
}
.active {
  border: 2px solid #58a0a8;
  border-radius: 8px;
}
.mzodiac {
  margin-top: 30px;
}
.btn-submit {
  margin-top: 50px;
}
input[type="text"] {
  color: white;
  text-align: center;
}
</style>
